import React, { Fragment, useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import favicon from "../../img/tuTrend.png";
import "../../styles/fonts.css";
import "../../styles/index.css";
import alt from "./default.png";
import Search from "../layouts/Search";
import UserContext from "../../context/user/userContext";
const AccountHeader = (props) => {
  const authContext = useContext(AuthContext);
  const userContext = useContext(UserContext);
  const { currentUser, logout } = authContext;
  useEffect(() => {
    return () => userContext.clearUser();
    //eslint-disable-next-line
  }, []);

  const onLogout = () => {
    logout();
    props.history.push("/");
  };
  return (
    <Fragment>
      <nav className='navbar navbar-dark bg-dark m-0'>
        <div className='col-xl-2 col-lg-2 col-md-4  col-11'>
          <Link
            to='/'
            className='navbar-brand text-light nolinklook'
            style={{ fontSize: "3em" }}
          >
            <img
              src={favicon}
              width='70'
              height='70'
              className='d-inline-block align-top'
              alt=''
              loading='lazy'
            />
            <span className='mainfont size11 mx-1'>tuTrend</span>
          </Link>
        </div>

        <Search history={props.history} />

        <div className='col-xl-5 col-lg-5 d-flex justify-content-between '>
          {currentUser && (
            <Fragment>
              <Link to='/uplode'>
                <button type='button' className='btn btn-light'>
                  <i className='fas fa-upload'></i>
                  <span className='d-none slantfont d-md-inline d-lg-inine d-xl-inline'>
                    Uplode
                  </span>
                </button>
              </Link>

              <button
                type='button'
                className='btn btn-light'
                onClick={onLogout}
              >
                <i className='fas fa-sign-in-alt'></i>
                <span className='d-none d-md-inline slantfont d-lg-inine d-xl-inline'>
                  Logout
                </span>
              </button>
              <Link
                className='nolinklook'
                to={`/viewaccount/${currentUser.uid}`}
                style={{ height: "100%" }}
              >
                <img
                  src={currentUser.photoURL || alt}
                  alt={currentUser.displayName}
                  loading='lazy'
                  width='40'
                  height='40'
                  className='rounded-circle border border-white'
                />
                <span className='text-light size09 titlefont '>
                  {currentUser.displayName}
                </span>
              </Link>
            </Fragment>
          )}
        </div>
      </nav>
      <nav className='navbar navbar-expand-lg nav nav-tabs navbar-dark bg-dark'>
        <button
          className='navbar-toggler'
          type='button'
          data-toggle='collapse'
          data-target='#navbarSupportedContent'
          aria-controls='navbarSupportedContent'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
          <ul className='navbar-nav mr-auto nav nav-tabs'>
            <li className='nav-item text-center'>
              <Link
                to={`/viewaccount/${
                  props.match.params.uid ||
                  (currentUser && currentUser.uid) ||
                  "*"
                }`}
                className='nav-link upperfont size09'
              >
                {" "}
                Home <span className='sr-only'>(current)</span>
              </Link>
            </li>
            <li className='nav-item text-center'>
              <Link
                to={`/account/videos/${
                  props.match.params.uid || (currentUser && currentUser.uid)
                }`}
                className='nav-link text-light upperfont size09'
                href='#'
              >
                {" "}
                Videos
              </Link>
            </li>
            <li className='nav-item text-center'>
              <Link
                to={`/account/notes/${
                  props.match.params.uid || (currentUser && currentUser.uid)
                }`}
                className='nav-link text-light upperfont size09'
                href='#'
              >
                {" "}
                Note's
              </Link>
            </li>
            {/*<li className='nav-item text-center'>
              <Link
                to='/account/notes'
                className='nav-link text-light upperfont size11'
                href='#'
              >
                {" "}
                <i className='fas fa-align-justify'></i> Playlist
              </Link>
            </li>*/}
          </ul>
        </div>
        <Link to='/' className='p-1 text-light'>
          <button className='btn btn btn-outline-light'>
            <i className='fas fa-sign-out-alt'>Back</i>
          </button>
        </Link>
      </nav>
    </Fragment>
  );
};
export default AccountHeader;
